import React from 'react';
import NotesListTable from './components/NotesListTable/NotesListTable';

const NotesList = () => {
  return <NotesListTable />;
};

export default NotesList;
